import { IconCheck } from '../../../components/Icon'

/**
 * Locked-state banner shown when the captain submitted the flight OR
 * the event went READ_ONLY (admin closed it). Copy distinguishes the
 * two cases so the player knows whether their flight ended or the
 * tournament itself wrapped.
 */
const LockedBanner = ({ eventIsReadOnly }: { eventIsReadOnly: boolean }) => (
  <div className="mx-4 my-3 px-4 py-3 rounded-lg bg-green-100 border border-green-500 text-green-800 text-sm flex items-center gap-3">
    <span
      aria-hidden
      className="w-6 h-6 rounded-full bg-green-700 text-paper flex items-center justify-center shrink-0"
    >
      <IconCheck size={14} />
    </span>
    <div className="flex-1">
      <div className="font-bold">
        {eventIsReadOnly ? 'Turneringen er avsluttet' : 'Scorekortet er levert'}
      </div>
      <div className="text-xs text-green-700">
        {eventIsReadOnly
          ? 'Resultatet er bekreftet. Se leaderboard og scorekort.'
          : 'Score kan ikke endres lenger. Se leaderboard og scorekort.'}
      </div>
    </div>
  </div>
)

export default LockedBanner
